<template>
  <van-popup
    id="popup"
    v-model="visible"
    position="left"
    :close-on-popstate="true"
  >
    <div class="top">
      <img class="back" :src="require('@/assets/images/icon_arrow_02.png')" @click="visible = false" alt="">
      <div class="user" @click="jumpRouter(personInfo.isLogin?'UserInfo':'Login')">
        <img class="avatar" :src="(userInfo && userInfo.avatar) || require('@/assets/images/avatar_default_01.png')" />
        <div class="content">
          <template v-if="personInfo.isLogin">
            <div class="name" v-if="personInfo.institute.id === -1 ">请完善信息</div>
            <div class="name" v-else>{{ userInfo.name || '未填写，点击填写'}}</div>
            <div class="level level1"></div>
          </template>
          <template v-else>
            <div class="name">立即登录</div>
          </template>
        </div>
        <img class="arrow" :src="require('@/assets/images/icon_arrow_02.png')" alt="">
      </div>
      <div class="progress">
        <div class="maxBar">
          <div class="indexBar" :style="`width: ${personInfo.isLogin?`${userInfo.experience/200*100}%`:0}`"></div>
        </div>
        <div class="rate">{{ personInfo.isLogin?`${userInfo.experience} / 200`:'0 / 0' }}</div>
      </div>
      <div class="price">
        <div class="item">
          <div class="title">余额</div>
          <div class="value">{{ personInfo.isLogin?userInfo.balance:0 | toFixed }}</div>
        </div>
        <div class="stick">|</div>
        <div class="item">
          <div class="title">积分</div>
          <div class="value">{{ personInfo.isLogin?userInfo.integral:0 }}</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="list">
        <div class="item" @click="jumpRouter('Activity',{params:{type: 'myActivityDetail'}})">
          <img class="icon" :src="require('@/assets/images/icon_personal_01.png')" alt="">
          <div class="title">我的活动</div>
          <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
        </div>
        <div class="item" @click="jumpRouter('Order')">
          <img class="icon" :src="require('@/assets/images/icon_personal_02.png')" alt="">
          <div class="title">我的订单</div>
          <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
        </div>
        <div class="item" @click="jumpRouter('Sign')">
          <img class="icon" :src="require('@/assets/images/icon_personal_03.png')" alt="">
          <div class="title">我的签到</div>
          <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
        </div>
        <div class="item" @click="jumpRouter('Collect')">
          <img class="icon" :src="require('@/assets/images/icon_personal_04.png')" alt="">
          <div class="title">我的收藏</div>
          <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
        </div>
        <div class="item" @click="jumpRouter('StudyRecord')">
          <img class="icon" :src="require('@/assets/images/icon_personal_05.png')" alt="">
          <div class="title">学习记录</div>
          <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
        </div>
        <div class="item" @click="jumpRouter('Exchange')">
          <img class="icon" :src="require('@/assets/images/icon_personal_06.png')" alt="">
          <div class="title">我的兑换</div>
          <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
        </div>
        <div class="item" @click="jumpRouter('More')">
          <img class="icon" :src="require('@/assets/images/icon_personal_07.png')" alt="">
          <div class="title">更多</div>
          <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
        </div>
      </div>
      <button class="logout" v-if="personInfo.isLogin" @click="logOut">退出登录</button>
    </div>
  </van-popup>
</template>

<script>
import { Dialog } from 'vant';
import { mapGetters } from 'vuex';
export default {
  name: 'PersonalPopup',
  data () {
    return {
      visible: false
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    // 获取用户信息
    ...mapGetters(['personInfo']),
    userInfo () {
      return this.personInfo ? this.personInfo.user : '';
    }
  },
  methods: {
    show () {
      this.visible = true;
    },

    /* 退出登录 */
    logOut () {
      const { $utils, $router } = this;

      Dialog.confirm({
        title: '提示',
        message: '是否退出登录'
      }).then(() => {
        this.$http.post('security/logout', {
          showLoading: true,
          loadingText: '退出中...'
        }).then((res) => {
          $utils.successToast({
            message: '退出成功！',
            onClose: () => {
              $router.push({
                name: 'Login'
              });
              this.visible = false;
              this.$utils.storage.remove('loginToken');
            }
          });
        });
      }).catch(() => {});
    },

    jumpRouter (name, other) {
      console.log('name--------', name);
      console.log('other++++++++', other);
      this.$router.push({ name, ...other });
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
#popup {
  width: 598px;
  height: 100vh;
  border-radius: 0 16px 16px 0;
  .top {
    width: 100%;
    height: 472px;
    padding-top: 26px;
    background: url('~@/assets/images/bg_blue_01.png') no-repeat center center/cover;
    .back {
      margin-left: 26px;
      width: 44px;
      height: 44px;
      transform:rotate(180deg);
    }
    .user {
      width: 478px;
      height: 80px;
      margin: 52px auto 0;
      display: flex;
      align-items: center;
      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: #F9F9F9;
      }
      .content {
        flex:1;
        height: 100%;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .name {
          width: 100%;
          font-size: 28px;
          line-height: 46px;
          color: #fff;
          overflow:hidden;
        }
        .level {
          width: 68px;
          height: 20px;
          font-size: 14px;
          color: #FFEED9;
          display: flex;
          align-items: center;
          padding-left: 36px;
        }
        .level1 {
          background: url('~@/assets/images/bg_level_01.png') no-repeat center center/cover;
        }
      }
      .arrow {
        width: 30px;
        height: 30px;
      }
    }
    .progress {
      margin: 28px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .maxBar {
        width: 406px;
        height: 16px;
        border-radius: 16px;
        background-color: rgba(255,255,255,.38);
        overflow: hidden;
        .indexBar {
          width: 35%;
          height: 100%;
          border-radius: 16px;
          background-color: #FCFCFC;
        }
      }
      .rate {
        margin-left: 16px;
        font-size: 22px;
        font-weight: 400;
        line-height: 48px;
        color: #fff;
      }
    }
    .price {
      margin-top: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title {
          font-size: 24px;
          font-weight: 400;
          line-height: 44px;
          color: #fff;
          opacity: 0.72;
        }
        .value {
          font-size: 40px;
          font-weight: 800;
          color: #fff;
        }
      }
      .stick {
        font-size: 40px;
        color: #fff;
        margin: 0 100px 0;
      }
    }
  }
  .bottom {
    margin-top: -16px;
    background-color: #fff;
    border-radius: 16px 16px 0 0;
    .list {
      .item {
        width: 100%;
        height: 100px;
        padding: 0 28px;
        display: flex;
        align-items: center;
        .icon {
          width: 36px;
          height: 36px;
        }
        .arrow {
          width: 28px;
          height: 28px;
        }
        .title {
          flex:1;
          margin-left: 24px;
          font-size: 26px;
          font-weight: 500;
          color: #333333;
        }
      }
    }
    .logout {
      margin: 24px auto 0;
      display: block;
      width: 470px;
      height: 80px;
      border: 2px solid #FF485D;
      background: #fff;
      border-radius: 40px;
      font-size: 26px;
      font-weight: 500;
      line-height: 48px;
      color: #FF485D;
    }
  }
}
</style>